"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _once = _interopRequireDefault(require("transmute/once"));

var LocalSettings = _interopRequireWildcard(require("crm_data/settings/LocalSettings"));

function logTimelineMountTiming() {
  // Making sure start_load_profile was actually marked
  if (window.performance.getEntriesByName('start_load_profile').length === 0) {
    return;
  }

  window.performance.measure('measure_load_profile', 'start_load_profile'); // Making sure the performance API is working as expected

  if (window.performance.getEntriesByName('measure_load_profile').length === 0) {
    return;
  }

  var duration = window.performance.getEntriesByName('measure_load_profile')[0].duration;

  if (LocalSettings.getFrom(localStorage, 'RECORD_TIMINGS')) {
    // eslint-disable-next-line no-console
    console.log('Timeline mount time since profile load: ', duration);
  }

  if (window.newrelic) {
    window.newrelic.setCustomAttribute('load_profile', duration);
    window.newrelic.setCustomAttribute('is_direct_profile_load', Boolean(window.isDirectProfileLoad));

    if (Math.random() * 100 < 5) {
      window.newrelic.addPageAction('crmProfileLoaded');
    }
  }

  window.isDirectProfileLoad = false;
}

var _default = (0, _once.default)(logTimelineMountTiming);

exports.default = _default;
module.exports = exports.default;